import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { SwitchUserComponent } from './components/switch-user/switch-user.component';
import { InstitutionRedirectComponent } from './components/institution-redirect/institution-redirect.component';
import { AuthGuard } from './services/auth.guard';
import { PasswordResetFlowComponent } from './components/password-reset-flow/password-reset-flow.component';

const routes: Routes = [
  {
    path: 'institution/:institutionId', // legacy redirect route - can be deleted once all apps have been updated and deployed
    component: InstitutionRedirectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'federation/:federationId/institution/:institutionId/redirect', // new redirect route - needed to be more explicit in order to exactly match institution ids in app links/universal links/deep links scheme (see wrapapp config.xml)
    component: InstitutionRedirectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'user',
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'switch',
        component: SwitchUserComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'password/reset',
        component: PasswordResetFlowComponent,
      },
      {
        path: 'password/reset/:token',
        component: PasswordResetFlowComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
